import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesCompras() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Órdenes y Embarques", items: [
      { label: "Ordenes de Compra", icon: "fas fa-shopping-basket", color: "#3b82f6", href: "/ListadoOrdenesCompra", desc: "Listado de OC", enabled: !!user.menu_oc },
      { label: "Pendiente Embarcar", icon: "fas fa-plane-departure", color: "#f59e0b", href: "/ListadoPendEmbarcar", desc: "OC por embarcar", enabled: !!user.pendiente_embarcar },
      { label: "Embarques", icon: "fas fa-ship", color: "#06b6d4", href: "/ListadoEmbarques", desc: "Contenedores en transito", enabled: !!user.embarques },
      { label: "Embarques Directos", icon: "fas fa-ship", color: "#14b8a6", href: "/EmbarquesDirectosCreate", desc: "Embarque sin OC previa", enabled: !!user.menu_compras },
      { label: "Pendiente Recibir", icon: "fas fa-plane-arrival", color: "#6366f1", href: "/ListadoPendRecibir", desc: "Embarques por recibir", enabled: !!user.pendiente_recibir },
    ]},
    { section: "Recepción", items: [
      { label: "Entradas", icon: "fas fa-cart-plus", color: "#10b981", href: "/ListadoCompras", desc: "Entradas a inventario", enabled: !!user.menu_compras },
      { label: "Compras Directas", icon: "fas fa-cart-plus", color: "#10b981", href: "/ComprasDirectasCreate", desc: "Compra en un paso", enabled: !!user.menu_compras },
      { label: "Control de Calidad", icon: "far fa-check-square", color: "#8b5cf6", href: "/RegistroControlCalidad", desc: "Registro de calidad", enabled: !!user.menuCalidad },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#ef4444", href: "/ListadoDevolucionesProveedores", desc: "Devolucion a proveedor", enabled: !!user.menu_compras },
    ]},
    { section: "Catálogos y Reportes", items: [
      { label: "Proveedores", icon: "fas fa-dolly", color: "#64748b", href: "/Proveedores", desc: "Padron de proveedores", enabled: !!user.menu_proveedores },
      { label: "Brokers", icon: "fas fa-user", color: "#64748b", href: "/ListadoBrokers", desc: "Agentes aduanales", enabled: !!user.menu_proveedores },
      { label: "Conceptos Gastos", icon: "fas fa-bars", color: "#64748b", href: "/ConceptosGastosEmbarques", desc: "Conceptos de embarque", enabled: !!user.menu_compras },
      { label: "Reporte Compras", icon: "fas fa-shopping-cart", color: "#3b82f6", href: "/ReporteCompras", desc: "Reporte general", enabled: !!user.menuCalidad },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Compras"
      descripcion="Ordenes, embarques y recepcion de mercancia"
      icono="fas fa-shopping-cart"
      color="#3b82f6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesCompras;
